import { render, staticRenderFns } from "./safetyProductionCost.vue?vue&type=template&id=709f0384&scoped=true&"
import script from "./safetyProductionCost.vue?vue&type=script&lang=js&"
export * from "./safetyProductionCost.vue?vue&type=script&lang=js&"
import style0 from "./safetyProductionCost.vue?vue&type=style&index=0&id=709f0384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f0384",
  null
  
)

export default component.exports